import { render, staticRenderFns } from "./jd_fj.vue?vue&type=template&id=3127495a&scoped=true"
import script from "./jd_fj.vue?vue&type=script&lang=js"
export * from "./jd_fj.vue?vue&type=script&lang=js"
import style0 from "./jd_fj.vue?vue&type=style&index=0&id=3127495a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127495a",
  null
  
)

export default component.exports